import ResultLogo from "@components/job_search/search_result_card/result_logo.tsx";
import TitleCompany from "@components/job_search/search_result_card/title_company.tsx";
import Tags from "@components/job_search/search_result_card/tags.tsx";
import Footer from "@components/job_search/search_result_card/footer.tsx";

interface Props {
  title: string;
  company: string;
  logoUrl: string;
  location?: string;
  payRange?: string;
  publishedAt: string;
  url: string;
  loading?: boolean;
  trackClick?: () => void;
}

export const SearchResultCard = ({
  title,
  company,
  logoUrl,
  location,
  payRange,
  publishedAt,
  url,
  loading,
  trackClick,
}: Props) => {
  return (
    <div
      className="flex flex-col p-6 gap-4 justify-between border-2 rounded-lg border-solid border-gray-00 bg-white"
      data-provides="search-result"
      data-loading={loading ? "true" : "false"}
    >
      <div className="flex flex-row items-center gap-2">
        <ResultLogo loading={loading} company={company} logoUrl={logoUrl} />
        <div className="flex flex-col">
          <TitleCompany loading={loading} company={company} title={title} />
        </div>
      </div>
      <div className="flex flex-row gap-4 flex-wrap">
        <Tags loading={loading} location={location} payRange={payRange} />
      </div>
      <div className="flex flex-row items-center justify-between">
        <Footer loading={loading} publishedAt={publishedAt} url={url} trackClick={trackClick} />
      </div>
    </div>
  );
};
